export const walletRoutes = [
  {
    path: 'wallet/recharge',
    name: 'WalletRecharge',
    component: () => import('@/views/_merchant/wallet/Recharge')
  },
  {
    path: 'wallet/orderList',
    name: 'WalletOrderList',
    component: () => import('@/views/_merchant/wallet/OrderList')
  },
  {
    path: 'wallet/orderDetail',
    name: 'WalletOrderDetail',
    component: () => import('@/views/_merchant/wallet/OrderDetail')
  },
  {
    path: 'wallet/ledgerList',
    name: 'WalletLedgerList',
    component: () => import('@/views/_merchant/wallet/LedgerList')
  },
  {
    path: 'wallet/bank',
    name: 'WalletBank',
    component: () => import('@/views/_merchant/wallet/Bank')
  },
  {
    path: '/wallet/creditdg/list',
    name: 'WalletCreditdgList',
    component: () => import('@/views/_merchant/wallet/creditdg/List'),
  },
]
